import { Component, ElementRef, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { NotificationService } from 'src/app/services/interceptor/notification';
import { ToastrService } from 'ngx-toastr';
import { DateFormatter } from 'src/app/models/datepickerformatterutil';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
declare var toastr: any;
declare var $: any;

@Component({
  selector: 'app-newassessment',
  templateUrl: './newassessment.component.html',
  styleUrls: ['./newassessment.component.css'],
})
export class NewassessmentComponent implements OnInit {
  headertext: string;
  activity: number;
  isEdit = false;
  classID: number;
  // errormessage:string;
  freezePage_formSubmissionInProgress = false;
  QuestionType_MultipleChoice = 'MultipleChoice';
  QuestionType_LongText = 'LongText';
  QuestionType_FileUpload = 'FileUpload';

  backtoConsoleRouteParams: any;

  headerBreadCrumbs: any;

  assessmentItem = {
    id: 0,
    name: '',
    questionType: '',
    endTime: '',
    startTime: '',
    timedType: '',
    rawEndTime: '',
    rawStartTime: '',
    duration: 0,
    weight: 100,
    batchID: 0,
    optional: false,
    essayTextLimit: 0,
    quizAssessment:false
  };

  AssessmentDeliveryMode_TimedAssessment = 'TimedAssessment';
  AssessmentDeliveryMode_UntimedAssessment = 'UntimedAssessment';
  assessmentID: any;
  browser: any;
  elementRef: ElementRef;
  isMultipleBatch = false;
  moduleId: number;

  constructor(
    elementRef: ElementRef,
    private activiatedroute: ActivatedRoute,
    private header: ComponentheaderService,
    private toaster: ToastrService,
    private router: Router,
    public assessmentManager: AssessmentmanagerService,
    private headerComponent: ComponentheaderService,
    private notification: NotificationService,
    public modulemanager: ModulemanagementService
  ) {
    headerComponent.setHeaderDisplay('Assessment Setup', [], []);
    //  this.elementRef= elementRef;
    // $(function () {
    //   debugger;
    //   $('#startt').datetimepicker();
    //   console.log('executed datetimepicker from angular2 app constructor');
    // });
  }

  async ngOnInit() {
    //debugger;
    let a = localStorage.getItem(
      this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache
    );
    // let dp=  $(this.elementRef.nativeElement).find('#datetimepicker1');
    // dp.draggable();
    this.browser = this.detectBrowser();
    this.classID = this.activiatedroute.snapshot.queryParams.classid;
    this.activity = this.activiatedroute.snapshot.queryParams.activity;
    this.assessmentID = this.activiatedroute.snapshot.queryParams.aid;

    if (this.activity == this.assessmentManager.activityType.Edit) {
      this.headertext =
        'Edit : ' +
        localStorage.getItem(
          this.assessmentManager.LocalStorage_FLAG.AssesmentTitle
        );
      this.isEdit = true;
    } else {
      this.headertext = 'Setup new Assessment';
    }

    if (this.isEdit) {
      await this.assessmentManager
        .getAssessmentBreadCrumb(this.assessmentID)
        .toPromise()
        .then((response: any) => {
          this.header.setHeaderDisplay(
            this.headertext,
            [
              {
                displaytext: 'School',
                route: `/user/schoolhome`,
                params: { schoolID: response.schoolID },
              },
              {
                displaytext: 'Course',
                route: `/user/moduledetails`,
                params: { moduleID: response.moduleID },
              },
              {
                displaytext: 'Lesson',
                route: `/user/lesson`,
                params: { classid: this.classID },
              },
              {
                displaytext: 'Assessments',
                route: `/user/assessmentconsole`,
                params: {
                  classid: this.classID,
                  batchid: this.assessmentItem.batchID,
                },
              },
              {
                displaytext: response.assessmentName,
                route: `/user/assessmentdetails`,
                params: {
                  classid: this.classID,
                  batchid: this.assessmentItem.batchID,
                  aid: response.assessmentID,
                },
              },
              {
                displaytext: this.headertext,
                route: `/user/editassessment`,
                params: { classid: this.classID, activity: this.activity },
              },
            ],
            []
          );
          this.moduleId = response.moduleID;
        });
    } else {
      await this.assessmentManager
        .getLessonBreadCrumb(this.classID)
        .toPromise()
        .then((response: any) => {
          this.header.setHeaderDisplay(
            this.headertext,
            [
              {
                displaytext: 'School',
                route: `/user/schoolhome`,
                params: { schoolID: response.schoolID },
              },
              {
                displaytext: 'Course',
                route: `/user/moduledetails`,
                params: { moduleID: response.moduleID },
              },
              {
                displaytext: 'Lesson',
                route: `/user/lesson`,
                params: { classid: this.classID },
              },
              {
                displaytext: 'Assessments',
                route: `/user/assessmentconsole`,
                params: {
                  classid: this.classID,
                  batchid: this.assessmentItem.batchID,
                },
              },
              {
                displaytext: this.headertext,
                route: `/user/newassessment`,
                params: { classid: this.classID, activity: this.activity },
              },
            ],
            []
          );
          this.moduleId = response.moduleID;
        });
    }
    this.isMultipleBatch =
      (
        await this.modulemanager
          .getCurrentModuleBatches(this.classID)
          .toPromise()
      ).length > 1;
    //debugger;
  }

  detectBrowser() {
    if (
      (navigator.userAgent.indexOf('Opera') ||
        navigator.userAgent.indexOf('OPR')) != -1
    ) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf('Chrome') != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf('Safari') != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf('Firefox') != -1) {
      return 'Firefox';
    } else if (navigator.userAgent.indexOf('MSIE') != -1) {
      return 'IE';
    } else {
      return 'Unknown';
    }
  }

  onSubmit(newA: NgForm) {
    //debugger;
    let formValue = $('#newA')[0];
    let stObj = $('#startt')[0];
    let etObj = $('#endt')[0];

    //let st =DateFormatter.convertDate(stObj.value);
    //let et= DateFormatter.convertDate(etObj.value);
    //     stObj = new Date(stObj.value);
    //     let startdateobj = {
    //       year: stObj.getFullYear(),
    //       month: stObj.getMonth(),
    //       day: stObj.getDate(),
    //       hour: stObj.getHours(),
    //       minute: stObj.getMinutes(),
    //     };

    //     etObj = new Date(etObj.value);
    //     let duedateobj = {
    //       year: etObj.getFullYear(),
    //       month: etObj.getMonth(),
    //       day: etObj.getDate(),
    //       hour: etObj.getHours(),
    //       minute: etObj.getMinutes(),
    //     };

    //  let   st = new Date(
    //       Date.UTC(
    //         startdateobj.year,
    //         startdateobj.month,
    //         startdateobj.day,
    //         startdateobj.hour,
    //         startdateobj.minute
    //       )
    //     );

    //   let  et = new Date(
    //       Date.UTC(
    //         duedateobj.year,
    //         duedateobj.month,
    //         duedateobj.day,
    //         duedateobj.hour,
    //         duedateobj.minute
    //       )
    //     );

    // if (st.getTime() > et.getTime()) {
    //   this.toaster.error(
    //     'Assessment start time can not be after due time',
    //     'Error'
    //   );
    //   return;
    // }
    // if (st.getTime() === et.getTime()) {
    //   this.toaster.error(
    //     'Assessment due time can not be the same as start time',
    //     'Error'
    //   );
    //   return;
    // }

    let wt = $('#weight')[0];
    let dr = $('#duration')[0];
    let frmData = {
      starttime: stObj.value,
      endtime: etObj.value,
      name: $('#name')[0].value,
      weight: wt.value ? wt.value : 0,
      duration: dr?.value ? dr.value : 0,
      optional: $('#optional')[0].value,
      quizAssessment: $('#quizAssessment')[0].value,
    };
    this.freezePage_formSubmissionInProgress = true;
    let formData: any;
    //this.loadingMessage = "Saving new Assessment. Please wait..."
    this.notification.currentNotificationType =
      this.notification.CALL_TYPE.POST_FORM_DATA;
    this.notification.notificationMessageBody = 'Saving Assessment...';
    this.notification.notificationMessageHeader = 'Saving';
    // if (newA.value.duration == "" || newA.value.duration == undefined || !newA.value.duration) {
    //   newA.value.duration = 0;
    // }
    // if (newA.value.weight == "" || newA.value.weight == undefined || !newA.value.weight) {
    //   newA.value.weight = 0;
    // }
    if (
      frmData.duration == '' ||
      frmData.duration == undefined ||
      !frmData.duration
    ) {
      frmData.duration = 0;
    }
    if (
      frmData.weight == '' ||
      frmData.weight == undefined ||
      !frmData.weight
    ) {
      frmData.weight = 0;
    }

    formData = {
      id: this.assessmentItem.id,
      classID: this.classID,
      timeZoneStartTime: frmData.starttime,
      timeZoneStopTime: frmData.endtime,
      name: frmData.name,
      weight: Number.parseFloat(frmData.weight),
      deliveryMode: newA.value.deliveryMode,
      assessmentType: newA.value.assessmentType,
      duration: Number.parseFloat(frmData.duration),
      optional: frmData.optional,
      essayTextLimit: newA.value.essayTextLimit,
      quizAssessment: newA.value.quizAssessment
    };
    if (!formData.timeZoneStartTime) {
      formData.timeZoneStartTime = '0001-01-01T00:00:00';
    }
    if (!formData.timeZoneStopTime) {
      formData.timeZoneStopTime = '0001-01-01T00:00:00';
    }
    
    if (this.isEdit == false) {
      this.assessmentManager
        .createAssessment(formData)
        .subscribe((data: any) => {
          this.toaster.success('Assessment Saved', 'Success');
          //navigate to details using the returned id
          this.router.navigate(['/user/assessmentdetails'], {
            queryParams: {
              aid: data,
              classid: this.classID,
              batchid: this.assessmentItem.batchID,
              target: this.assessmentManager.bufferRoute.Details,
            },
          });
        })
        .add(() => {
          this.freezePage_formSubmissionInProgress = false;
        });
    } else {
      this.assessmentManager
        .updateAssessment(formData)
        .subscribe((data: any) => {
          //navigate to details using the returned id
          this.toaster.success('Assessment Updated', 'Success');
          this.router.navigate(['/buffer'], {
            queryParams: {
              classid: this.classID,
              aid: data,
              batchid: this.assessmentItem.batchID,
              target: this.assessmentManager.bufferRoute.Details,
            },
          });
          //  this.router.navigate(['/buffer'], {queryParams:{id:data,classid:this.classID}});
        })
        .add(() => {
          this.freezePage_formSubmissionInProgress = false;
        });
    }
  }

  ngAfterViewInit() {
    if (this.isEdit) {
      this.assessmentItem = JSON.parse(
        localStorage.getItem(
          this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache
        )
      );
      this.assessmentItem.batchID=0;
      if (this.assessmentItem.rawStartTime == '0001-01-01T00:00:00') {
        this.assessmentItem.rawStartTime = null;
      }
      if (this.assessmentItem.rawEndTime == '0001-01-01T00:00:00') {
        this.assessmentItem.rawEndTime = null;
      }
    }
    //JQUERY - CODE FOR MANAGING ASSESSMENT CREATION - NOT REQUIRED FOR EDITING
    $('#adm').on('change', function (event) {
      if ('UntimedAssessment' == $(this).val()) {
        $('#durationHolder').hide();
        $('#duration').val('0');
      } else {
        $('#durationHolder').show();
      }
    });

    const assessmentTimedType = this.assessmentItem.timedType;
    $('#crt-new-asmt').on('click', function (e) {
      if (
        ($('#adm').val() === 'TimedAssessment' ||
          assessmentTimedType === 'TimedAssessment') &&
        $('#duration').val() == 0
      ) {
        e.preventDefault();
        toastr.error('Please provide a duration for the TIMED Assessment');
      }
    });

    // debugger;
    // $(function () {
    //  // debugger;
    //   // $('#datetimepicker1').datepicker();
    //   // $(this.elementRef.nativeElement).find;
    //   //  $('#startt').datepicker();
    // });

    // debugger;
    //    $(document).ready(function () {
    //      debugger;
    //      $('#datetimepicker1').draggable();
    //     // $('#datetimepicker1').datetimepicker.setLocale('en');

    //    });
  }
}
